import React from 'react';

export default ({ fields }) => {
  const hasShortcode = !!fields.shortcode;
  const hasParent = !!fields['parent.name'];
  return (
    <span className='related-links'>
    <span className="display-id-wrapper">
      <span className={`fa fa-fw fa-${fields.icon} mr-2`} />
      <span className="display-id">
        {hasShortcode ? fields.shortcode : fields.name}
      </span>
      <div className={`support-type-badge ${fields['support.class']}`}>
        {
          fields['support.icon'] ? <span className={`fa fa-fw fa-${fields['support.icon']}`} /> : null
        }
        {
          fields['support.type']
        }
      </div>
    </span>
    <span className="subject">
      {
        hasShortcode ?
          fields['namespaced_name']
          : hasParent ?
            fields['parent.name']
            : fields.site.name
      }
    </span>
  </span>
  );
}
